module.exports = __webpack_public_path__ + "img/default-user.dc8b1732.png";